import React from 'react'
import { ThemeProvider } from '@rmwc/theme'
import '@rmwc/theme/styles'
import themeColors from '../constants/themeColors'

import { Radio as NRadio } from '@rmwc/radio'
import '@rmwc/radio/styles'
// import './NuRadio.scss'

// --vars

// --components
function Radio ({ label, ...rest }) {
  return (
    <ThemeProvider options={{ secondary: themeColors.primary }}>
      <NRadio
        {...{ ...rest }}
      >
        {label}
      </NRadio>
    </ThemeProvider>
  )
}

// --functions

// --mappings
export default Radio
